import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Settings, Bell, User, Shield } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import NotificationSettings from '../components/NotificationSettings';

const ParametresNotifications = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6" data-testid="parametres-notifications-page">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Paramètres</h1>
        <p className="text-gray-500 text-sm">Gérez vos préférences et notifications</p>
      </div>

      {/* Settings Tabs */}
      <Tabs defaultValue="notifications" className="w-full">
        <TabsList className="grid w-full grid-cols-2 lg:w-[400px]">
          <TabsTrigger value="notifications" className="flex items-center gap-2">
            <Bell className="w-4 h-4" />
            Notifications
          </TabsTrigger>
          <TabsTrigger value="compte" className="flex items-center gap-2">
            <User className="w-4 h-4" />
            Mon compte
          </TabsTrigger>
        </TabsList>

        <TabsContent value="notifications" className="mt-6">
          <NotificationSettings />
        </TabsContent>

        <TabsContent value="compte" className="mt-6">
          <div className="bg-white rounded-xl p-6 shadow-sm border">
            <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <User className="w-5 h-5 text-teal-500" />
              Informations du compte
            </h3>
            
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Nom</p>
                  <p className="font-medium">{user?.nom || '-'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Prénom</p>
                  <p className="font-medium">{user?.prenom || '-'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Email</p>
                  <p className="font-medium">{user?.email || '-'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Rôle</p>
                  <p className="font-medium capitalize">{user?.role || '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ParametresNotifications;
